<div class="col-12">
    <div class="row align-items-center">
        <img src="./assets/icons/arrow.svg">
        <span class="section-title ml-2">Créditos Distribuídos</span>
    </div>
    <div class="row mt-4">
        <div *ngIf="chartData" class="col-12 p-0 white">
            <chart *ngIf="ready" [type]="type" [data]="data" [options]="options"></chart>
        </div>
    </div>
</div>
